<template>
  <fragment>
    <AppBody title="Operações" subtitle="Equipamentos" :actions="actions">
      <v-form
        @submit.prevent="$operacoes_equipamentos.filtroEquipamentos()"
        class="search-forms"
      >
        <v-row>
          <v-col cols="3">
            <label class="input-labels">Descrição</label>
            <v-text-field
              solo
              placeholder="Insira a descrição do equipamento"
              v-model="$operacoes_equipamentos.filter.descricao"
              type="text"
              data-cy="descricao"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Tipo</label>
            <v-select
              height="48"
              :items="tipo_equipamento"
              dense
              solo
              data-cy="tipo"
              class="textinput"
              item-text="text"
              item-value="value"
              v-model="$operacoes_equipamentos.filter.tipo_equipamento"
              placeholder="Selecione o tipo"
              :color="$config.dados.corinputs"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear-icon="clearFilterFields('tipo')"
              :item-color="$config.dados.corinputs"
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Status</label>
            <v-select
              height="48"
              :items="status"
              dense
              solo
              data-cy="status"
              class="textinput"
              item-text="text"
              item-value="value"
              v-model="$operacoes_equipamentos.filter.status"
              placeholder="Selecione o status"
              :color="$config.dados.corinputs"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear-icon="clearFilterFields('status')"
              :item-color="$config.dados.corinputs"
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Número de Série</label>
            <v-text-field
              solo
              placeholder="Insira a descrição do equipamento"
              v-model="$operacoes_equipamentos.filter.serie_equipamento"
              type="text"
              data-cy="numero-serie"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="2" data-cy="filtrar" class="ml-auto align-self-end">
            <v-btn height="48" class="button btn-border btn-size" type="submit">
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        class="table-totals-body"
        no-data-text="Não há registro de equipamentos."
        loading-text="Buscando informações..."
        :loading="$operacoes_equipamentos.loading"
        :headers="headers"
        :items="$operacoes_equipamentos.equipamentos"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Equipamentos por página:',
        }"
      >
        <template v-slot:item.dthr_ativacao="{ item }">
          {{
            item.dthr_ativacao
              ? dayjs(item.dthr_ativacao).format("DD/MM/YYYY")
              : "-"
          }}
        </template>
        <template v-slot:item.numero_serie="{ item }">
          {{ item.numero_serie ? item.numero_serie : "-" }}
        </template>
        <template v-slot:item.representante_nome="{ item }">
          {{ item.representante_nome ? item.representante_nome : "-" }}
        </template>
        <template v-slot:item.tipo="{ item }">
          {{ item.tipo === "PDV" ? "QR CODE" : item.tipo }}
        </template>
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  :loading="item.edit_button_loading"
                  v-bind="attrs"
                  v-on="on"
                  @click="goToEquips('editar', item)"
                  class="mr-2"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.status == 'ATIVO'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="
                    $operacoes_equipamentos.desabilitarEquipamento(
                      item.idequipamento
                    )
                  "
                >
                  <v-icon>mdi-cellphone-remove</v-icon>
                </v-btn>
              </template>
              <span>Inativar</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="
                    $operacoes_equipamentos.habilitarEquipamento(
                      item.idequipamento
                    )
                  "
                >
                  <v-icon>mdi-cellphone-check</v-icon>
                </v-btn>
              </template>
              <span>Ativar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </AppBody>
    <ModalConfirmacao
      :textModal="$operacoes_equipamentos.text"
      @callback="$operacoes_equipamentos.funcaoRemover"
    />
  </fragment>
</template>

<script>
import dayjs from "dayjs";
import { mapActions } from "vuex";
export default {
  name: "Equipments",
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
  },
  metaInfo: {
    title: "Equipamentos | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Equipamentos | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      dayjs: dayjs,
      actions: [
        {
          name: "Novo Equipamento",
          action: () => this.goToEquips("new", ""),
        },
      ],
      headers: [
        {
          text: "Número de série",
          align: "center",
          sortable: true,
          value: "numero_serie",
          width: 180,
        },
        {
          text: "Ponto de Venda",
          align: "center",
          sortable: true,
          value: "representante_nome",
          width: 200,
        },
        {
          text: "Descrição",
          align: "center",
          sortable: true,
          value: "descricao",
          width: 150,
        },
        {
          text: "Tipo de Equipamento",
          align: "center",
          sortable: true,
          value: "tipo",
          width: 200,
        },
        {
          text: "Data de Ativação",
          align: "center",
          sortable: true,
          value: "dthr_ativacao",
          width: 180,
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
          width: 150,
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions",
          width: 100,
        },
      ],
      tipo_equipamento: [
        {
          text: "POS",
          value: "POS",
        },
        {
          text: "QR CODE",
          value: "PDV",
        },
      ],
      status: [
        {
          text: "ATIVO",
          value: "ATIVO",
        },
        {
          text: "INATIVO",
          value: "INATIVO",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchEventsOfAnyStore"]),
    goToEquips(type, data) {
      this.$operacoes_equipamentos.equipamentosAddEdit = type;
      if (type === "editar") {
        this.$operacoes_equipamentos.cadastro.aplicar_taxa =
          data.aplicar_comissao_ou_taxa;
        this.$operacoes_equipamentos.cadastro.idequipamento =
          data.idequipamento;
        this.$operacoes_equipamentos.cadastro.tipo_equipamento = data.tipo;
        this.$operacoes_equipamentos.cadastro.status = data.status;
        this.$operacoes_equipamentos.cadastro.rede_vendas = data.rede_vendas;
        this.$operacoes_equipamentos.cadastro.lojas = Object.keys(
          data.produtos_sync
        ).map(Number);
        this.fetchEventsOfAnyStore({
          producers: this.$operacoes_equipamentos.cadastro.lojas,
        });

        if (this.$operacoes_equipamentos.cadastro.lojas.length > 0) {
          this.$operacoes_equipamentos.cadastro.events = Object.values(
            data.produtos_sync
          ).reduce((acc, arr) => acc.concat(arr), []);
        }
        this.$operacoes_equipamentos.cadastro.descricao = data.descricao;
        this.$operacoes_equipamentos.cadastro.data_ativacao = dayjs(
          data.dthr_ativacao
        ).format("DD/MM/YYYY");
        this.$operacoes_equipamentos.cadastro.numero_serie = data.numero_serie;
        this.$operacoes_equipamentos.cadastro.is_app = data.is_app
          ? data.is_app
          : 0;
        this.$operacoes_equipamentos.cadastro.link_vendas = data.link_vendas
          ? data.link_vendas
          : "";
        if (data.idponto_venda) {
          this.$operacoes_equipamentos.cadastro.idpdv_empty = false;
          this.$operacoes_equipamentos.cadastro.point_sale = data.idponto_venda;
          this.$router.push({
            name: "equipmentsSettings",
            params: { type: "editar" },
          });
          return;
        }
        this.$operacoes_equipamentos.cadastro.idpdv_empty = true;
      }
      this.$router.push({
        name: "equipmentsSettings",
        params: { type: "cadastrar" },
      });
      if (type == "new") {
        this.$operacoes_equipamentos.cadastro.aplicar_taxa = 1;
      }
    },
    clearFilterFields(field) {
      switch (field) {
        case "tipo":
          this.$operacoes_equipamentos.filter.tipo_equipamento = "";
          break;
        case "status":
          this.$operacoes_equipamentos.filter.status = "";
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.$operacoes_equipamentos.getEquipamentos();
  },
};
</script>
<style scoped>
.produtos-gerenciar-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button2 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  position: relative;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
